<template>
  <div class="footer">
    <div class="box">
      <div class="left">
        <img :src="require('@/assets/img_svg/logo_white.svg')" alt="svg" />
        <!-- <div class="decl  reveal-bottom">
                    <span>负责声明</span>
                    <span>隐私策略</span>
                </div> -->
      </div>
      <div class="item reveal-bottom">
        <h2>{{ $t("h.solution") }}</h2>
        <router-link class="link" :to="{ name: 'Retail' }">{{
          $t("h.isp")
        }}</router-link>
        <router-link class="link" :to="{ name: 'Enterprise' }">{{
          $t("h.enterprise")
        }}</router-link>
      </div>
      <div class="item reveal-bottom" style="flex-basis: 80px">
        <h2>{{ $t("h.product") }}</h2>
        <router-link class="link" :to="{ name: 'CloudXpressConnect' }">{{
          $t("h.cxc")
        }}</router-link>
        <router-link class="link" :to="{ name: 'CloudSaasAccerlation' }">{{
          $t("h.csa")
        }}</router-link>

        <router-link class="link" :to="{ name: 'GlobalAppAccess' }">{{
          $t("h.gaa")
        }}</router-link>
        <router-link class="link" :to="{ name: 'MobileClient' }">{{
          $t("h.mobility")
        }}</router-link>
        <router-link class="link" :to="{ name: 'Hardware' }">{{
          $t("h.hardware")
        }}</router-link>
      </div>
      <!-- <div class="item reveal-bottom">
                <h2>{{ $t("h.customer") }}</h2>
                <router-link class="link" :to="{ name: 'CustomerCaseStudy' }">{{
                    $t("h.ccs")
                }}</router-link>

                <router-link class="link" :to="{ name: 'CustomerCaseStudy' }">{{
                    $t("h.Education")
                }}</router-link>
                <router-link class="link" :to="{ name: 'CustomerCaseStudy' }">{{
                    $t("h.Energy")
                }}</router-link>
                <router-link class="link" :to="{ name: 'CustomerCaseStudy' }">{{
                    $t("h.Financial")
                }}</router-link>
            </div> -->
      <div class="item reveal-bottom">
        <h2>{{ $t("h.technology") }}</h2>
        <router-link class="link" :to="{ name: 'SDWAN' }">SDWAN</router-link>
        <router-link class="link" :to="{ name: 'WhitePager' }">{{
          $t("h.wp")
        }}</router-link>
        <router-link class="link" :to="{ name: 'Download' }">{{
          $t("h.download")
        }}</router-link>
        <router-link class="link" :to="{ name: 'Support' }">{{
          $t("h.Support")
        }}</router-link>
        <router-link class="link" :to="{ name: 'Partner' }">{{
          $t("h.cooperation")
        }}</router-link>
      </div>
      <div class="item reveal-bottom">
        <h2>{{ $t("h.aboutUs") }}</h2>
        <router-link class="link" :to="{ name: 'Overview' }">{{
          $t("h.overview")
        }}</router-link>
        <router-link class="link" :to="{ name: 'ExpertTeam' }">{{
          $t("h.et")
        }}</router-link>
        <router-link class="link" :to="{ name: 'Awards' }">{{
          $t("h.awards")
        }}</router-link>

        <router-link class="link" :to="{ name: 'News' }">{{
          $t("h.news")
        }}</router-link>
      </div>
    </div>
    <div class="a-link reveal-bottom">
      <span>{{ isOShen ? $t("h.oshen") : $t("h.rep") }}</span> |
      {{ $t("h.rep1") }}
      <template v-if="isHost">
        <a
          class="aa"
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          >粤ICP备17154947号-1</a
        >
        <a
          class="aa"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502005871"
          >粤公网安备 44030502005871号</a
        >
      </template>

      <template v-if="isOBC">
        <a
          class="aa"
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          >粤ICP备19101973号</a
        >
        <a
          class="aa"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502005821"
          >粤公网安备 44030502005821号</a
        >
      </template>

      <template v-if="isCn">
        <a
          class="aa"
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          >粤ICP备17154947号-2</a
        >
      </template>

      <template v-if="isComCn">
        <a
          class="aa"
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          >粤ICP备19101973号-4</a
        >
      </template>

      <template v-if="isSC">
        <a
          class="aa"
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          >蜀ICP备2020030739号</a
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    // console.log(/oceanbluecloud\.com.cn/g.test("oceanbluecloud.com.cn"));
    // console.log(/oceanbluecloud\.com.cn/g.test("oceanbluecloud.com"));
    return {
      isOBC: /oceanbluecloud\.tech/g.test(location.host) ? true : false,
      isHost: /oceanbluecloud\.com.cn/g.test(location.host)
        ? false
        : /oceanbluecloud\.com/g.test(location.host)
        ? true
        : false,
      isCn: /oceannetwork\.cn/g.test(location.host) ? true : false,
      isSC: /wisecloudsdwan\.com/g.test(location.host) ? true : false,
      isComCn: /oceanbluecloud\.com.cn/g.test(location.host) ? true : false,
      isOShen: /oshentech\.com/g.test(location.host) ? true : false,
    };
  },
};
</script>
<style scoped>
.aa {
  color: #fff;
}
.aa:hover {
  text-decoration: underline;
}
.footer {
  height: 539px;
  background-color: #312f38;
  overflow: hidden;
}
.box {
  width: 1200px;
  display: flex;
  margin: 90px auto 0;
  height: 238px;
}
.left {
  flex-basis: 340px;
  width: 340px;
}
.item {
  flex: 1;
}
.logo {
  height: 23px;
  margin-left: -62px;
}
.decl {
  margin-top: 175px;
  font-size: 12px;
  color: #ffffff;
  line-height: 22px;
}
.decl > span:nth-child(1) {
  padding-right: 11px;
  position: relative;
  cursor: pointer;
}
.decl > span:nth-child(1)::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 12px;
  top: 3px;
  right: 0;
  background-color: #fff;
}
.decl > span:nth-child(2) {
  padding-left: 10px;
  cursor: pointer;
}
.item {
  flex: 1;
  position: relative;
  padding-left: 28px;
  box-sizing: border-box;
}
.item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  height: 238px;
  background-color: rgba(255, 255, 255, 0.1);
  transform: scaleX(0.5);
}
.item > h2 {
  font-size: 22px;
  color: #ffffff;
  line-height: 30px;
  font-weight: bold;
  margin-bottom: 35px;
  cursor: default;
}
.link {
  display: block;
  font-size: 14px;
  color: #ffffff;
  line-height: 30px;
  cursor: pointer;
}
.a-link {
  width: 1200px;
  margin: 132px auto 0;
  line-height: 78px;
  font-size: 12px;
  color: #ffffff;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue